export const prContent = [
  {
    heroTitle: "Private Rental Sector Services",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "Trusted By The Biggest PRS Management Agents",
    introText: `
We've built a reputation for providing quick and efficient services for the private rental sector. We work with some of the biggest PRS Management Agencies in Leeds and West Yorkshire`,
  },
  {
    contLeftTitle: "Landlords and Letting Agnecies",
    contLeftText: `When plumbing and heating issues arise tenants contact their landlord or letting agency, who in turn contact AquaHeat for a fast response.`,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643105735/AquaHeat/new%20images/Screenshot_2022-01-25_at_09.27.42_x1st8s.webp`,
  },
  {
    contRightTitle: "Complete Peace Of Mind",
    contRightText: `Whenever your tenants need a plumber or heating engineer, AquaHeat is here 24/7 365 days a year giving landlords total peace of mind.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643106019/AquaHeat/new%20images/Screenshot_2022-01-25_at_10.19.31_cuogry.webp`,
  },
  {
    callToActionTitle: "For Our Lettings Team Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
